import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDriverStore } from '../../store/driverStore';
import { useAlertManager } from '../../components/AlertProvider';
import { MaterialCommunityIcons } from '../../utils/icons';
import { Colors } from '../../theme/colors';
import { formatDate } from '../../utils/dateUtils';
import './DocumentsScreen.css';

const DocumentsScreen: React.FC = () => {
  const navigate = useNavigate();
  const { showAlert } = useAlertManager();
  const { documents, getDocuments, uploadDocument, getVerificationStatus } = useDriverStore();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDocuments();
  }, []);

  const loadDocuments = async () => {
    setLoading(true);
    await getDocuments();
    await getVerificationStatus();
    setLoading(false);
  };

  const handleUpload = async (documentType: string) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*,.pdf';
    input.onchange = async (e: any) => {
      const file = e.target.files?.[0];
      if (file) {
        const docNumber = prompt('Enter document number:');
        if (docNumber) {
          try {
            await uploadDocument(file, documentType, docNumber);
            showAlert('Success', 'Document uploaded successfully', [{ text: 'OK' }]);
            loadDocuments();
          } catch (error: any) {
            showAlert('Error', error.message || 'Failed to upload document', [{ text: 'OK' }]);
          }
        }
      }
    };
    input.click();
  };

  const requiredDocuments = [
    { type: 'DRIVER_LICENSE', label: 'Driver License', icon: 'card-account-details' },
    { type: 'VEHICLE_REGISTRATION', label: 'Vehicle Registration', icon: 'car-multiple' },
    { type: 'INSURANCE', label: 'Insurance', icon: 'shield-check' },
  ];

  if (loading) {
    return <div className="documents-loading"><div className="loading-spinner"></div></div>;
  }

  return (
    <div className="documents-container">
      <div className="documents-header">
        <button onClick={() => navigate('/')}><MaterialCommunityIcons name="arrow-back" size={24} /></button>
        <h1>Driver Documents</h1>
      </div>
      <div className="documents-content">
        {requiredDocuments.map((docType) => {
          const doc = documents.find((d) => d.document_type === docType.type);
          return (
            <div key={docType.type} className="document-card">
              <div className="document-header">
                <MaterialCommunityIcons name={docType.icon} size={24} color={Colors.primary} />
                <span>{docType.label}</span>
                {doc && <span className={`status-badge ${doc.verification_status}`}>{doc.verification_status}</span>}
              </div>
              {doc && (
                <div className="document-details">
                  <p>Number: {doc.document_number}</p>
                  <p>Uploaded: {formatDate(doc.uploaded_at)}</p>
                </div>
              )}
              <button onClick={() => handleUpload(docType.type)}>
                {doc ? 'Update' : 'Upload'}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DocumentsScreen;







